import type { Novidade } from './tipos';

/** Fase 2 (W18, K2 e K3): a Agenda agenda pelo catálogo de Serviços e os cadastros que faltavam ganharam importação. */
export const novidadeAgendaServicos: Novidade = {
  id: '2026-10-05-agenda-servicos',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: 'agenda',
  permissao: 'agenda.ver',
  textos: {
    pt: {
      titulo: 'A Agenda usa o catálogo de Serviços',
      resumo: 'Os serviços para agendar vêm de Cadastros > Serviços, com a duração e quem faz. Mais cadastros com importação por planilha.',
      passos: [
        'Em Cadastros > Serviços, marque Agendável e informe a duração e quem faz o serviço.',
        'No Novo agendamento da Agenda, a lista de serviços é a do catálogo: um só lugar para cadastrar.',
        'Os lembretes da Agenda agora ficam em Cadastros > Profissionais e recursos.',
        'Projetos, Tags e setores, Contas e caixas e Profissionais e recursos ganharam Baixar modelo e Importar.',
      ],
    },
    en: {
      titulo: 'The Schedule uses the Services catalog',
      resumo: 'Services to book come from Records > Services, with the duration and who does them. More records can be imported from a spreadsheet.',
      passos: [
        'In Records > Services, check Bookable and fill in the duration and who does the service.',
        'In the Schedule New appointment, the service list is the catalog one: a single place to register.',
        'The Schedule reminders now live in Records > Staff and resources.',
        'Projects, Tags and sectors, Accounts and cash and Staff and resources got Download template and Import.',
      ],
    },
    es: {
      titulo: 'La Agenda usa el catálogo de Servicios',
      resumo: 'Los servicios para agendar vienen de Registros > Servicios, con la duración y quién los hace. Más registros con importación por planilla.',
      passos: [
        'En Registros > Servicios, marca Agendable e informa la duración y quién hace el servicio.',
        'En Nueva cita de la Agenda, la lista de servicios es la del catálogo: un solo lugar para registrar.',
        'Los recordatorios de la Agenda ahora están en Registros > Profesionales y recursos.',
        'Proyectos, Etiquetas y sectores, Cuentas y cajas y Profesionales y recursos tienen Descargar plantilla e Importar.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-agenda-servicos/servico-agendavel.webp', null, null, null],
  treinamento: { curso: 'novidades' },
  rota: '/cadastros/cadastros/servicos',
};
